import React from "react";
import MobileNonNachaTemplateListTableRow from "../MobileNonNachaTemplateListTableRow";
import { MobileNoEntriesTableRow } from "components/shared/views/TableView/components/MobileNoEntriesTableRow";

import "./styles.css";

/**
 * @function MobileNonNachaTemplateListTable
 * @return {React.Component}
 * @exported true
 * @description This is the mobile non nacha template table for NonNachaTemplateListWidget
 */
export default function MobileNonNachaTemplateListTable(props) {
    return (
        <div className="mobile-non-nacha-template-list-table">
            {/* <MobileNonNachaTemplateListTableRow /> */}
            <MobileNoEntriesTableRow text="You do not have any templates setup. Please choose a file above to create a new template." />
        </div>
    )
}